import { html, nothing } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { InternalI18n } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/i18n/internal-i18n-controller.js';
import styles from './breadcrumb.scss.js';
import { locales } from './locales.js';
import '@cigna/cigna_csg_gsg_cipublic-icon/cipublic-icon.js';
/**
 * cipublic-breadcrumb
 */
export class BreadCrumb extends CipublicElement {
    constructor() {
        super(...arguments);
        this.i18n = new InternalI18n(this, locales);
    }
    static get styles() {
        return [styles];
    }
    connectedCallback() {
        super.connectedCallback();
        // gives enough time for children to be defined
        this.initialChildren = Array.from(this.children).filter((element) => {
            return !(element.nodeName === 'SLOT') && !element.slot;
        });
    }
    render() {
        var _a;
        if (this.initialChildren.length) {
            return html `<nav aria-label="${this.i18n.t('breadcrumbs_aria')}"><ol>${(_a = this.initialChildren) === null || _a === void 0 ? void 0 : _a.map((child) => html `<li>${child}${child.tagName === 'CIPUBLIC-LINK'
                ? html `<cipublic-icon set="system" name="chevron-right"></cipublic-icon>`
                : html `${nothing}`}</li>`)}</ol></nav>`;
        }
        else {
            return html ``;
        }
    }
}
//# sourceMappingURL=breadcrumb.js.map